<template>
    <div>
    <!-- 详情 --> 
    <a-drawer
            width="85%"
            :height="340"
            :visible="detailVisible"
            placement="right"
            :footer="false"
            @cancel="handleCancel"
            unmountOnClose
    >
        <template #title>【{{ detail.auto_code }}】{{ detail.company_name }} </template>

        <a-tabs :active-key="activeKey" @change="tabClick">
            <a-tab-pane key="1" :title="$t('base.detail')"></a-tab-pane>
            <a-tab-pane key="2" :title="$t('order.openPosition')"></a-tab-pane>
            <a-tab-pane key="3" :title="$t('order.priceList')"></a-tab-pane>
        </a-tabs>

        <a-spin :loading="loading" tip="Loading...">
            <div v-if="activeKey == 1" class="baseInfo">
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.saleManager2')" /></span> 
                            <span class="fieldValue">{{detail.sale_manager_name}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.isActive2')" /></span> 
                            <span class="fieldValue">{{detail.active_flag}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.testCenter2')" /></span> 
                            <span class="fieldValue">{{detail.test_flag}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.serviceCenter2')" /></span> 
                            <span class="fieldValue">{{detail.service_flag}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.bico')" /></span> 
                            <span class="fieldValue">{{detail.bico}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.salesNote')" /></span> 
                            <span class="fieldValue" style="white-space: break-spaces;word-break: break-all;padding-right: 80px;vertical-align: top;">{{detail.sales_note}}</span> 
                        </div>
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.customerClassification2')" /></span> 
                            <span class="fieldValue">{{detail.classification}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.commitment2')" /></span> 
                            <span class="fieldValue">{{detail.commitment}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.potential2')" /></span> 
                            <span class="fieldValue">{{detail.potential}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.financialInformation2')" /></span> 
                            <span class="fieldValue" style="width:80%;white-space: break-spaces;word-break: break-all;padding-right: 20px;vertical-align: top;">{{detail.financial_information}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.estimate2')" /><span class="estimateYear">{{detail.year}}</span></span> 
                            <span class="fieldValue">{{detail.estimate}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.dzbNumber')" /></span> 
                            <span class="fieldValue">{{detail.dzb_number}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.contractSigned')" /></span> 
                            <span class="fieldValue">{{detail.contract_signed}}</span> 
                        </div>
                        <div class="detailItem detailItem_head">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.c2cFlag')" /></span> 
                            <span class="fieldValue">{{detail.c2c_flag}}</span> 
                        </div>
                    </div>
                </div>
                
                <!-- 基础信息 -->
                <a-divider orientation="left" style="margin-top:30px;font-weight:600"><icon-star /> {{ $t('base.companyInfo') }}</a-divider>
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.shopName')" /></span> 
                            <span class="fieldValue">{{detail.shop_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.phone')" /></span> 
                            <span class="fieldValue">{{detail.phone}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.mobile')" /></span> 
                            <span class="fieldValue">{{detail.mobile}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.zip')" /></span> 
                            <span class="fieldValue">{{detail.zip}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.website')" /></span> 
                            <span class="fieldValue">{{detail.website}}</span> 
                        </div>
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.city')" /></span> 
                            <span class="fieldValue">{{detail.city}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.street')" /></span> 
                            <span class="fieldValue">{{detail.street}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.houseNumber')" /></span> 
                            <span class="fieldValue">{{detail.house_number}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.location')" /></span> 
                            <span class="fieldValue">{{detail.location}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('config.vatNo')" /></span> 
                            <span class="fieldValue" style="width:80%;white-space: break-spaces;word-break: break-all;padding-right: 20px;vertical-align: top;">{{detail.vat_no}}</span> 
                        </div>
                    </div>
                </div>

                <!-- 店铺信息 -->
                <a-divider orientation="left" style="font-weight:600"><icon-star /> {{ $t('dealer.storeInfo') }}</a-divider>
                <!-- <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.storeCity')" /></span> 
                            <span class="fieldValue">{{detail.store_city}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.storeAddress')" /></span> 
                            <span class="fieldValue">{{detail.store_address}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.storeHouseNumber')" /></span> 
                            <span class="fieldValue">{{detail.store_house_number}}</span> 
                        </div>
                        
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.storeZip')" /></span> 
                            <span class="fieldValue">{{detail.store_zip}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.storePhone')" /></span> 
                            <span class="fieldValue">{{detail.store_phone}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.storeEmail')" /></span> 
                            <span class="fieldValue">{{detail.store_email}}</span> 
                        </div>
                    </div>
                </div> -->

                <Table 
                    :table="storeAddressTable"
                >
                    <!--  自定义表头筛选 -->
                    <template v-slot:searchFilter="{ props }">
                        <div class="searchFilter">
                            <a-space direction="vertical">
                                <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" @press-enter="props.handleFilterConfirm"/>
                                <div class="searchFilter-footer">
                                    <a-button style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                                    <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                                </div>
                            </a-space>
                        </div>
                    </template>
                </Table>

                <a-divider orientation="left" style="font-weight:600"><icon-star /> {{ $t('dealer.deliveryInfo') }}</a-divider>
                <!-- 收货信息 -->
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.deliveryCity')" /></span> 
                            <span class="fieldValue">{{detail.delivery_city}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.deliveryAddress')" /></span> 
                            <span class="fieldValue">{{detail.delivery_address}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.deliveryHouseNumber')" /></span> 
                            <span class="fieldValue">{{detail.delivery_house_number}}</span> 
                        </div>
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.deliveryZip')" /></span> 
                            <span class="fieldValue">{{detail.delivery_zip}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.deliveryPhone')" /></span> 
                            <span class="fieldValue">{{detail.delivery_phone}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.deliveryEmail')" /></span> 
                            <span class="fieldValue">{{detail.delivery_email}}</span> 
                        </div>
                    </div> 
                </div>

                <!-- 其他信息 -->
                <a-divider orientation="left" style="font-weight:600"><icon-star /> {{ $t('dealer.otherInfo') }}</a-divider>
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.salesAreaApprox')" /></span> 
                            <span class="fieldValue">{{detail.sales_area_approx}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.branches')" /></span> 
                            <span class="fieldValue" >{{detail.branches}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.branchesReamrk')" /></span> 
                            <span class="fieldValue" style="width:80%;white-space: break-spaces;word-break: break-all;padding-right: 20px;vertical-align: top;">{{detail.branches_remark}}</span> 
                        </div>
                        <!-- <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.saleManager2')" /></span> 
                            <span class="fieldValue">{{detail.sale_manager_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.isActive2')" /></span> 
                            <span class="fieldValue">{{detail.active_flag}}</span> 
                        </div> -->
                    </div>
                    <div class="detailItem_right">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.serviceWorkshop')" /></span> 
                            <span class="fieldValue">{{detail.service_workshop}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.foundation')" /></span> 
                            <span class="fieldValue">{{detail.foundation}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.portfolio')" /></span> 
                            <span class="fieldValue" style="width:80%;white-space: break-spaces;word-break: break-all;padding-right: 20px;vertical-align: top;">{{detail.portfolio}}</span> 
                        </div>
                        <!-- <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('dealer.testCenter2')" /></span> 
                            <span class="fieldValue">{{detail.test_flag}}</span> 
                        </div> -->
                    </div>
                </div>
            </div>

            <div v-if="activeKey == 2">
                <div class="queryPanel">
                    <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                        <Form
                            :form="queryForm"
                            @handleSelectChange="handleSelectChange"
                            @handlePressEnter="handlePressEnter"
                            @handleInputClear=handleInputClear
                            @handlePickerDateChange="handlePickerDateChange"
                            @handleFetchSearch="handleFetchSearch"
                        >
                            <template v-slot:formBtn>
                                <a-dropdown-button size="small" @click="handle('search')">
                                    <icon-search size="14" style="marginRight:5px;"/>
                                    {{ $t('base.search') }}
                                    <template #content>
                                        <a-doption @click="handle('reset')">
                                            <icon-refresh size="14" style="marginRight:5px;"/>
                                            {{ $t('base.reset') }}
                                        </a-doption>
                                    </template>
                                </a-dropdown-button>
                            </template>
                        </Form>
                    </div>
                </div>

                <Table
                    :table="opoTable"
                    @changePage="changePage"
                    @changePageSize="changePageSize"
                >
                    <template v-slot:operate>
                        <a-button v-permission="'setting.order.createOrder'" type="primary" size="small" :disabled="exporting" @click="exportData">
                            <icon-export size="13" style="margin-right:5px;"/>
                            {{ $t('base.export') }}
                        </a-button>
                    </template>

                    <template v-slot:columns="{ props }">
                        <div v-if="props.column.key == 'pay_status'">
                            <a-tag 
                                v-if="props.record.pay_status !== '-'" 
                                :color="payStatusColor[props.record.pay_status_val]"
                            >{{ props.record.pay_status }}</a-tag>
                        </div>
                    </template> 
                </Table>
            </div>

            <div v-if="activeKey == 3">
                <div class="queryPanel">
                    <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                        <Form
                            :form="queryForm2"
                            @handleSelectChange="handleSelectChange"
                            @handlePressEnter="handlePressEnter"
                            @handleInputClear=handleInputClear
                            @handlePickerDateChange="handlePickerDateChange"
                            @handleFetchSearch="handleFetchSearch"
                        >
                            <template v-slot:formBtn>
                                <a-dropdown-button size="small" @click="handle('search')">
                                    <icon-search size="14" style="marginRight:5px;"/>
                                    {{ $t('base.search') }}
                                    <template #content>
                                        <a-doption @click="handle('reset')">
                                            <icon-refresh size="14" style="marginRight:5px;"/>
                                            {{ $t('base.reset') }}
                                        </a-doption>
                                    </template>
                                </a-dropdown-button>
                            </template>
                        </Form>
                    </div>
                </div>

                <Table
                    :table="priceTable"
                    @changePage="changePage"
                    @changePageSize="changePageSize"
                >
                    <template v-slot:operate>
                        <a-button v-permission="'setting.order.createOrder'" type="primary" size="small" :disabled="exporting" @click="exportData">
                            <icon-export size="13" style="margin-right:5px;"/>
                            {{ $t('base.export') }}
                        </a-button>
                    </template>

                    <template v-slot:columns="{ props }">
                        <div v-if="props.column.key == 'pay_status'">
                            <a-tag 
                                v-if="props.record.pay_status !== '-'" 
                                :color="payStatusColor[props.record.pay_status_val]"
                            >{{ props.record.pay_status }}</a-tag>
                        </div>
                    </template> 
                </Table>
            </div>
        </a-spin>
    </a-drawer>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { DealerApi } from '@/api/DealerApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { IconSearch } from '@arco-design/web-vue/es/icon';
    import { DetailForm, DetailForm2 } from './queryConfig/DetailQuery.js';


    const props = defineProps({
        row:{
            type:Object,
            default:()=>{}
        },
        detailVisible:{
            type:Boolean,
            default:false,
        },
    })

    const emits = defineEmits(['handleCancel'])

    const { t } = useI18n()

    const loading = ref(true)
    const title = ref('')
    const detail = ref({})
    const queryForm = reactive(DetailForm)
    const queryForm2 = reactive(DetailForm2)
    const activeKey = ref('1')
    const exporting = ref(false)

    const storeAddressTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '城市',
                title: t('dealer.storeCity'),
                dataIndex: 'store_city',
                key:'store_city',
                // width:'260',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                filterable: {
                    filter: (value, record) => record.store_city.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '店铺地址',
                title: t('dealer.storeAddress'),
                dataIndex: 'store_address',
                key:'store_address',
                // width:'220',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                filterable: {
                    filter: (value, record) => record.store_address.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '店铺门牌号',
                title: t('dealer.storeHouseNumber'),
                dataIndex: 'store_house_number',
                key:'store_house_number',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                filterable: {
                    filter: (value, record) => record.store_house_number.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '邮编',
                title: t('dealer.storeZip'),
                dataIndex: 'store_zip',
                key:'store_zip',
                width:'90',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filter: (value, record) => record.store_zip.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '手机号',
                title: t('dealer.storePhone'),
                dataIndex: 'store_phone',
                key:'store_phone',
                // width:'240',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filter: (value, record) => record.store_phone.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '邮箱',
                title: t('dealer.storeEmail'),
                dataIndex: 'store_email',
                key:'store_email',
                // width:'110',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filter: (value, record) => record.store_email.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:380,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const opoTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
            },
            {
                title:t('order.orderNumber'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'180',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.shipmentNotificationNumber'),
                dataIndex: 'invoice_child_type',
                key:'invoice_child_type',
                width:'210',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.invoiceNumber'),
                dataIndex: 'invoice_no',
                key:'invoice_no',
                width:'130',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.invoiceDate'),
                dataIndex: 'invoice_date',
                key:'invoice_date',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.dueDate'),
                dataIndex: 'due_date',
                key: 'due_date',
                width: '110',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.amountTotal'),
                dataIndex: 'invoice_amount_str',
                key: 'invoice_amount_str',
                width: '140',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.amountPaid'),
                dataIndex: 'real_pay_amount_str',
                key: 'real_pay_amount_str',
                width: '120',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.paid'),
                dataIndex: 'pay_status',
                key: 'pay_status',
                width: '170',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                slotName:'slot',
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                y:500,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        }
    })

    const priceTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
            },
            {
                title:t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'130',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.productName'),
                dataIndex: 'erp_item_name',
                key:'erp_item_name',
                width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('financial.priceListName'),
                dataIndex: 'price_list_name',
                key:'price_list_name',
                width:'130',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('order.unitPrice'),
                dataIndex: 'unit_price',
                key:'unit_price',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                y:500,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        }
    })

    const orderStatus = ref({  // 订单状态
        // '-1':t('order.finalPayment'), // 尾款单
        '0':t('order.partialPay'), // 部分付款
        '1':t('order.pay'), // 支付
        // '2':t('order.refund'), // 全额退款
        // '3':t('order.returnsAndRefund'),
        // '4':t('order.partialRefund'), // 部分退款
        // '5':t('order.partialReturnsAndRefund'),
        // '6':t('order.canceled'), // 取消
        '7':t('order.obligation') // 待付款
    })

    const payStatusColor = ref({
        // '-1': 'arcoblue', // 尾款单
        '0': '#ff4500', // 部分付款
        '1': 'green', // 支付
        // '2': 'pink', // 全额退款
        // '4': 'gold', // 部分退款
        // '6': 'gray', // 取消
        '7': '#ad0606', // 待付款
    })

    const tabClick = (val)=>{
        activeKey.value = val
    }

    const handle = (type)=>{
        switch(type){
            case 'search':
                if(activeKey.value == '2'){
                    opoTable.value.configs.pagination.current = 1
                    getOpoList()
                }else if(activeKey.value == '3'){
                    priceTable.value.configs.pagination.current = 1
                    getPriceList()
                }
                break;
            case 'reset':
                if(activeKey.value == '2'){
                    queryForm.formField.forEach(i=> queryForm.formData[i.key] = '')
                    queryForm.formData.begin_date = ''
                    queryForm.formData.end_date = ''
                    getOpoList()
                }else if(activeKey.value == '3'){
                    queryForm2.formField.forEach(i=> queryForm2.formData[i.key] = '')
                    getPriceList()
                }
                break;
        }
    }

    const init = ()=>{
        title.value = t('base.detail')
        
        for(let key in props.row){
            props.row[key] = props.row[key] === '' || props.row[key] === undefined? '-' : props.row[key]
        }
        detail.value = JSON.parse(JSON.stringify(props.row)) 
        
        detail.value.shop_name = !props.row.shop_name? '-' : props.row.shop_name
        detail.value.mobile = !props.row.mobile? '-' : props.row.mobile
        detail.value.website = !props.row.website? '-' : props.row.website
        detail.value.vat_no = !props.row.vat_no? '-' : props.row.vat_no
        detail.value.location = !props.row.location? '-' : props.row.location
        detail.value.house_number = !props.row.house_number? '-' : props.row.house_number

        detail.value.sales_area_approx = !props.row.sales_area_approx || props.row.sales_area_approx == '-'? '-' : `${props.row.sales_area_approx} m²`
        detail.value.branches = !props.row.branches? '-' : props.row.branches
        detail.value.branches_remark = !props.row.branches_remark? '-' : props.row.branches_remark
        detail.value.service_workshop = !props.row.service_workshop? '-' : props.row.service_workshop
        detail.value.foundation = !props.row.foundation? '-' : props.row.foundation
        detail.value.portfolio = !props.row.portfolio? '-' : props.row.portfolio

        detail.value.sale_manager_name = !props.row.sale_manager_name? '-' : props.row.sale_manager_name
        detail.value.active_flag = props.row.active_flag === undefined? '-' : props.row.active_flag_val == 0? t('base.NO') : t('base.YES')
        detail.value.test_flag = props.row.test_flag === undefined? '-' : props.row.test_flag_val == 'YES'? t('base.YES') : t('base.NO')
        detail.value.service_flag = props.row.service_flag === undefined? '-' : props.row.service_flag_val == 'YES'? t('base.YES') : t('base.NO')
        detail.value.classification = props.row.classification === undefined? '-' : props.row.classification_val == 1? 'A (200)' : props.row.classification_val == 2? 'B (100)' : props.row.classification_val == 3? 'C (<100)' : 'D (Service)'
        detail.value.commitment = props.row.commitment === undefined? '-' : props.row.commitment_val == 'Low'? t('dealer.low') : props.row.commitment_val == 'Mid'?  t('dealer.middle') : t('dealer.high')
        detail.value.financial_information = props.row.financial_information_val === undefined? '-' : props.row.financial_information_val
        detail.value.yearEstimateList = props.row.yearEstimateList
        detail.value.estimate = props.row.yearEstimateList.length > 0? props.row.yearEstimateList[0].estimate : '-'
        detail.value.year = props.row.yearEstimateList.length > 0? props.row.yearEstimateList[0].year : ''
        detail.value.dzb_number = !props.row.dzb_number? '-' : props.row.dzb_number
        detail.value.contract_signed = !props.row.contract_signed? '-' : props.row.contract_signed
        detail.value.c2c_flag = props.row.c2c_flag === undefined? '-' : props.row.c2c_flag == 1? t('base.YES') : t('base.NO')
        detail.value.potential = !props.row.potential? '-' : props.row.potential
        detail.value.bico = !props.row.bico? '-' : props.row.bico
        detail.value.sales_note = !props.row.sales_note? '-' : props.row.sales_note

        storeAddressTable.value.datas = []
        detail.value.store_address_list && detail.value.store_address_list.length > 0 && detail.value.store_address_list.forEach((i, index)=>{
            storeAddressTable.value.datas.push({
                No: index + 1,
                store_city: !i.city? '-' : i.city,
                store_address: !i.street? '-' : i.street,
                store_house_number: !i.house_number? '-' : i.house_number,
                store_zip: !i.zip? '-' : i.zip,
                store_phone: !i.phone? '-' : i.phone,
                store_email: !i.email? '-' : i.email,
            })
        })

        loading.value = false

        console.log(detail.value, 'detail.value')

        getOpoList()
        getPriceList()
        getSKUList()
    }

    const changePage = (current)=>{
        switch(activeKey.value){
            case '2':
                opoTable.value.configs.pagination.current = current
                getOpoList()
                break;
            case '3': 
                priceTable.value.configs.pagination.current = current
                getPriceList()
                break;
        }
    }

    const changePageSize = (pageSize)=>{
        switch(activeKey.value){
            case '2':
                opoTable.value.configs.pagination.current = 1
                opoTable.value.configs.pagination.pageSize = pageSize
                getOpoList()
                break;
            case '3': 
                priceTable.value.configs.pagination.current = 1
                priceTable.value.configs.pagination.pageSize = pageSize
                getPriceList()
                break;
        }
    }

    const handleInputClear = (val,item)=>{
        switch(activeKey.value){
            case '2':
                opoTable.value.configs.pagination.current = 1
                getOpoList()
                break;
            case '3': 
                priceTable.value.configs.pagination.current = 1
                getPriceList()
                break;
        }
    }
    
    const handlePressEnter = (val, item)=>{
        switch(activeKey.value){
            case '2':
                opoTable.value.configs.pagination.current = 1
                getOpoList()
                break;
            case '3': 
                priceTable.value.configs.pagination.current = 1
                getPriceList()
                break;
        }
    }

    const handleSelectChange = (val, item, key)=>{
        console.log(val, item, key, 'val, item')
        switch(activeKey.value){
            case '2':
                opoTable.value.configs.pagination.current = 1
                getOpoList()
                break;
            case '3': 
                priceTable.value.configs.pagination.current = 1
                getPriceList()
                break;
        }
    }

    const handlePickerDateChange = (val)=>{
        opoTable.value.configs.pagination.current = 1
        queryForm.formData.begin_date = !val? '' : dateToTimestamp(`${val[0]} 00:00:00`)
        queryForm.formData.end_date = !val? '' : dateToTimestamp(`${val[1]} 23:59:59`) 
        getOpoList()
    }

    const handleCancel = ()=>{
        queryForm.formField.forEach(i=> queryForm.formData[i.key] = '')
        queryForm.formData.begin_date = ''
        queryForm.formData.end_date = ''
        queryForm2.formField.forEach(i=> queryForm2.formData[i.key] = '')
        activeKey.value = '1'
        emits('handleCancel')
    }

    const getOpoList = async ()=>{
        let form = {}
        for(let key in queryForm.formData){
            if(key != 'invoice_date'){
                form[key] = queryForm.formData[key]
            }
        }

        let param = {
            ...form,
            customer_erp_code: props.row.auto_code,
        }
        let page_num = opoTable.value.configs.pagination.current
        let page_size = opoTable.value.configs.pagination.pageSize

        let res = await DealerApi.getInstance().getOpoList(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.forEach((item,index)=>{
                item.No = index + 1
                item.real_pay_amount_str = item.real_pay_amount_str == undefined? '-' : `€ ${item.real_pay_amount_str}`
                item.invoice_amount_str = item.invoice_amount_str == undefined? '-' : `€ ${item.invoice_amount_str}`
                item.pay_status_val = item.pay_status
                item.pay_status = item.pay_status == undefined? '-' : orderStatus.value[`${item.pay_status}`]
                item.invoice_child_type = item.invoice_child_type == undefined? '-' : item.invoice_child_type
            })
            opoTable.value.datas = res.data.records
            opoTable.value.configs.pagination.total = res.data.total
        }else{
            Message.error(res.msg)
        }
    }  
    
    const exportData = async ()=>{
        exporting.value = true
        let form = {}

        if(activeKey.value == '2'){
            for(let key in queryForm.formData){
                if(key != 'invoice_date'){
                    form[key] = queryForm.formData[key]
                }
            }
            form.customer_erp_code = props.row.auto_code
        }else if(activeKey.value == '3'){
            for(let key in queryForm2.formData){
                form[key] = queryForm2.formData[key]
            }
            form.customer_number = props.row.auto_code
        }
        

        let param = {
            ...form
        }

        let res = activeKey.value == '2'
                ? await DealerApi.getInstance().exportOpo(param)
                : await DealerApi.getInstance().exportPrice(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = activeKey.value == '2'? `${t('order.openPositionData')}.xlsx` : `${t('order.priceListData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            exporting.value = false 
        }else{  
            Message.error(res.msg)
        }
    }

    const getPriceList = async ()=>{
        let param = {
            ...queryForm2.formData,
            customer_number: props.row.auto_code,
        }
        let page_num = priceTable.value.configs.pagination.current
        let page_size = priceTable.value.configs.pagination.pageSize

        let res = await DealerApi.getInstance().getPriceList(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.forEach((item,index)=>{
                item.No = index + 1
                item.unit_price = item.unit_price == undefined? '-' : `€ ${item.unit_price}`
   
            })
            priceTable.value.datas = res.data.records
            priceTable.value.configs.pagination.total = res.data.total
        }else{
            Message.error(res.msg)
        }
    }  

    // 获取产品列表,拿到SKU下拉数据
    const getSKUList = async ()=>{
        let res = await OrderApi.getInstance().getProductList({category_code: "627.501", inventory_item_status_code: 'Active'}) 
        if(res.code == 0){
            let item = queryForm2.formField.find(i=> i.key == 'sku')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.sku,
                    value:i.sku,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }


    watch(()=>props.detailVisible,async (val)=>{
        init()
    })

    onMounted(()=>{
        
    })
</script>

<style lang="less" scoped>
.detailItem{
    padding-left: 30px;
    line-height: 20px;
    white-space: nowrap;
    
    .fieldName{
        display: inline-block;
        width: 190px;
        color: #333;
    }
    .fieldValue{
        display: inline-block;
        color: #888;
        vertical-align: -webkit-baseline-middle;
    }
}

.detailItem_head{
    // margin-bottom: 10px;
    font-weight: 600;

    .estimateYear{
        font-size: 12px;
        margin-left: 10px;
        vertical-align: bottom;
    }
}

.detailItemParent{
    display: flex;
    width: 100%;
    padding: 5px 0 20px;
    .detailItem_left,
    .detailItem_right{
        display: flex;
        flex: 1;
        flex-direction: column;
        padding-right: 100px;
    }
}

/deep/ .arco-divider-text{
    font-weight: bold;
}

/deep/ .baseInfo{
    .table_pagination{
        display: none;
    }
} 

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

/deep/ .arco-form-item-layout-inline{
    margin-right:0;
}

/deep/  .arco-table-container{
    padding-bottom: 0;
}

.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}
</style>